<template>
  <div>
    <grade-list v-show="tabType === 1" @handleShow="handleShow" />
    <grade-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import gradeList from './list.vue'
import gradeShow from './show.vue'
export default {
  components: { gradeList, gradeShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>